import React from "react";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import { getNetTradeProfit } from "../utils/tradeStats";

const formatMetricValue = (value, decimals = 2) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return "0";
  }

  return numericValue.toFixed(decimals);
};

const RiskExposureWidget = ({ positions = [], accountInfo = {} }) => {
  const floatingProfit = positions.reduce((sum, position) => sum + getNetTradeProfit(position), 0);
  const accountBalance = Number(accountInfo.balance) || 0;
  const totalRiskAmount = positions.reduce(
    (sum, position) => sum + (Number(position.risk_amount_gbp) || 0),
    0,
  );
  const percentBalanceAtRisk = accountBalance > 0
    ? (totalRiskAmount / accountBalance) * 100
    : 0;

  const exposureBySymbol = positions.reduce((symbolMap, position) => {
    const symbol = position.symbol || "Unknown";
    const volume = Number(position.volume) || 0;
    symbolMap[symbol] = (symbolMap[symbol] || 0) + volume;
    return symbolMap;
  }, {});

  const [largestExposureSymbol = "-", largestExposureVolume = 0] = Object.entries(exposureBySymbol)
    .sort((a, b) => b[1] - a[1])[0] || [];

  const metricCards = [
    {
      label: "% Balance At Risk",
      value: formatMetricValue(percentBalanceAtRisk),
      suffix: "%",
    },
    { label: "Total Risk", value: formatMetricValue(totalRiskAmount), suffix: "", prefix: "£" },
    // { label: "Largest Pair", value: largestExposureSymbol, suffix: largestExposureSymbol === "-" ? "" : ` (${formatMetricValue(largestExposureVolume)} total volume)` },
    { label: "Floating Net P/L", value: formatMetricValue(floatingProfit), suffix: "", prefix: "£" },
  ];

  return (
    <Card className="app-widget-panel shadow-sm">
      <CardBody>
        <CardTitle tag="h5" className="app-widget-title">
          Risk Exposure
        </CardTitle>
        <Row className="g-3 app-widget-grid">
          {metricCards.map((metric) => (
            <Col xs={6} md={6} xl={4} key={metric.label} className="app-widget-grid__col">
              <div className="app-metric-card">
                <span className="app-metric-label">{metric.label}</span>
                <span className="app-metric-value">
                  {metric.prefix || ""}
                  {metric.value}
                  {metric.suffix}
                </span>
              </div>
            </Col>
          ))}
        </Row>
      </CardBody>
    </Card>
  );
};

export default RiskExposureWidget;
